import axios from 'axios'
import { useToaster } from '../hooks/useToaster';

export const  httpReq = axios.create({
    baseURL: process.env.REACT_APP_DEV_API_URL,
    timeout: 30000,
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:3000',
      'Access-Control-Allow-Credentials': 'true',
      'Content-Type': 'application/json; charset=utf-8'
    },
    transformRequest: [
      (data) => {
        return JSON.stringify(data);
      },
    ],
  });
  
  export const httpReqAuth = axios.create({
    baseURL: process.env.REACT_APP_DEV_API_URL,
    timeout: 30000,
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:3000',
      'Access-Control-Allow-Credentials': 'true',
      'Content-Type': 'application/json; charset=utf-8',
    },
    transformRequest: [
      (data) => {
        return JSON.stringify(data);
      },
    ],
  });


  httpReqAuth.interceptors.response.use(
    (response) => {
      
      return response;
    },
    (error) => {
      // localStorage.removeItem('token');
      console.log(error);
      useToaster(error.response.data.message)
      return Promise.reject(error);
    },
  );

  httpReqAuth.interceptors.request.use(
  (response) => {
    return response;
  },
  (error) => {
    // localStorage.removeItem('token');
    useToaster(error.response.data.message)
    return Promise.reject(error);
  },
);

  httpReq.interceptors.request.use(
    async (config) => {
      const token = await localStorage.getItem('token');
      config.headers['Authorization'] = 'Bearer ' + token;
      return config;
    },
    (error) => {
        useToaster(error.response.data.message)
      
      return Promise.reject(error);
    },
  );
  

  httpReq.interceptors.response.use(
    (response) => {
      
      return response;
    },
    async function (error) {

        useToaster(error.response.data.message)
      return Promise.reject(error.response);
    },
  );

 